module.exports = __webpack_public_path__ + "img/user-10.1a961789.png";